import { useQuery, UseQueryOptions } from 'react-query';

import { fetchJson } from '@zapier/toolbox-browser-fetch';

import { ZAPIER_APP_BASE_URL } from 'app/common/constants';
import { useNotify } from 'app/developer-v3/hooks';

import type { IssueNotificationSettings } from './types';

type Args = { integrationId: number };

const QUERY_KEY_PREFIX = 'query-issue-notification-settings';
const getQueryKey = (args: Args) => `${QUERY_KEY_PREFIX}-${args.integrationId}`;

function formatResponseBody(body: any): IssueNotificationSettings {
  return {
    ccContact: {
      id: body.cc_contact?.id,
      email: body.cc_contact?.email,
    },
    developer: {
      id: body.developer?.id,
      email: body.developer?.email,
    },
    shouldNotifyDeveloper: body.should_notify_developer,
  };
}

function useQueryIssueNotificationSettings(
  args: Args,
  options?: UseQueryOptions<
    IssueNotificationSettings,
    Error,
    IssueNotificationSettings
  >
) {
  const { integrationId } = args;
  const notify = useNotify();

  const queryKey = getQueryKey({ integrationId });
  const url = new URL(
    `api/platform/cli/apps/${encodeURIComponent(
      integrationId
    )}/notification-settings`,
    ZAPIER_APP_BASE_URL
  );

  const query = useQuery({
    queryKey,
    queryFn: async () => formatResponseBody(await fetchJson(url.href)),
    onError: async (error: any) => notify.failure(error.message, queryKey),
    ...options,
  });

  return { ...query, queryKey };
}

export default useQueryIssueNotificationSettings;
export { getQueryKey, QUERY_KEY_PREFIX };
